import { Link } from 'react-router-dom';

interface Props {
  name: string;
  parentName: string | null;
  onAddSubregion: () => void;
  editTo: string;
}

/** Breadcrumb + title + actions (edit in builder / add subregion) for the detail page. */
export function RegionDetailHeader({ name, parentName, onAddSubregion, editTo }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div className="nb-eyebrow" style={{ fontSize: 9, color: 'var(--nb-subtle)' }}>
        <Link to="/admin/regions" style={{ color: 'inherit', textDecoration: 'none' }}>
          Regions
        </Link>
        {parentName ? ` › ${parentName} › ${name}` : ` › ${name}`}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2
          className="nb-display"
          style={{ margin: 0, fontSize: 19, color: 'var(--nb-bark-dark)' }}
        >
          {name}
        </h2>
        <span style={{ flex: 1 }} />
        <Link to={editTo} className="nb-btn" style={{ fontSize: 12, textDecoration: 'none' }}>
          Edit in builder
        </Link>
        <button
          type="button"
          className="nb-btn nb-btn-primary"
          style={{ fontSize: 12 }}
          onClick={onAddSubregion}
        >
          Add subregion
        </button>
      </div>
    </div>
  );
}
